export default {
    namespaced: true,
    state: {
    // 在线用户列表
        onlineUsers: []
    },
    mutations: {
        updateOnlineUsers (state, onlineUsers) {
            state.onlineUsers = onlineUsers;
        }
    }
};
